import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TrainingService } from 'app/_services/training.service';
import * as PDFJS from 'pdfjs-dist/build/pdf';

@Component({
  selector: 'pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
})
export class PdfViewerComponent implements AfterViewInit {
  @Input() src: string;
  @Output() onPdfEnd = new EventEmitter<any>();
  @ViewChild('pdfCanvas', { static: true }) pdfCanvas: ElementRef;

  private pdf: any;
  public currentPage = 1;
  public maxPages = 1;
  public isLoading = true;
  private isRendering: boolean;
  private pageNumPending: number;

  constructor(
    private trainingService: TrainingService,
  ) {
    PDFJS.GlobalWorkerOptions.workerSrc = './assets/pdfjs/pdf.worker.min.js';
  }

  ngAfterViewInit() {
    this.trainingService.getFileUrl(this.src).subscribe(fileUrl => {
      // isEvalSupported: false mitigates CVE-2024-4367 (https://security.snyk.io/vuln/SNYK-JS-PDFJSDIST-6810403).
      // The fixed pdfjs-dist 4.2.67+ cannot be bundled by the current webpack 4 build.
      PDFJS.getDocument({ url: fileUrl, isEvalSupported: false }).promise.then(pdf => {
        if (this.pdf) {
          this.pdf.destroy();
        }
        this.pdf = pdf;
        const numPages = pdf.numPages;
        this.maxPages = numPages;

        if (numPages === 1) {
          this.onPdfEnd.emit();
        }

        this.queueRenderPage(1);
      }).catch(error => {
        console.log(error);
      });
    });
  }

  private render(pageNum: number) {
    this.isLoading = true;
    this.isRendering = true;

    const canvas = this.pdfCanvas.nativeElement;
    const context = canvas.getContext('2d');

    this.pdf.getPage(pageNum).then(page => {
      const viewport = page.getViewport({ scale: 1 });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      let renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      let renderTask = page.render(renderContext);

      renderTask.promise.then(() => {
        this.isRendering = false;
        this.isLoading = false;

        if (this.pageNumPending) {
          this.render(this.pageNumPending);
          this.pageNumPending = null;
        }
      });
    });
  }

  private queueRenderPage(num) {
    if (this.isRendering) {
      this.pageNumPending = num;
    } else {
      this.render(num);
    }
  }

  public nextPage() {
    if (this.currentPage >= this.maxPages) {
      return;
    }
    this.isLoading = true;
    this.currentPage++;
    this.queueRenderPage(this.currentPage);

    if (this.currentPage === this.maxPages) {
      this.onPdfEnd.emit();
    }
  }

  public previousPage() {
    if (this.currentPage <= 1) {
      return;
    }
    this.isLoading = true;
    this.currentPage--;
    this.queueRenderPage(this.currentPage);
  }

  public openFile() {
    this.trainingService.openFile(this.src);
  }
}
